import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Star, Sparkles } from 'lucide-react';
import { trackAddToCart } from '../lib/metaPixel';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 0.8,
  delay,
  ease: [0.21, 0.47, 0.32, 0.98]
}} className={className} data-id="element-363">
    {children}
  </motion.div>;
export const SectionDivider = () => <div className="w-full flex items-center justify-center py-16 opacity-60" data-id="element-364">
    <div className="h-px bg-gradient-to-r from-transparent via-gold/50 to-transparent w-1/3 max-w-[200px]" data-id="element-365"></div>
    <div className="mx-4 text-gold flex gap-2" data-id="element-366">
      <Star size={12} className="opacity-50" data-id="element-367" />
      <Moon size={16} data-id="element-368" />
      <Star size={12} className="opacity-50" data-id="element-369" />
    </div>
    <div className="h-px bg-gradient-to-r from-gold/50 via-gold/50 to-transparent w-1/3 max-w-[200px]" data-id="element-370"></div>
  </div>;
export const BadgeLabel = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => <div className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-gold/30 bg-mystic-800/80 text-gold text-xs font-bold tracking-widest uppercase ${className}`} data-id="element-371">
    <Sparkles size={12} data-id="element-372" />
    {children}
    <Sparkles size={12} data-id="element-373" />
  </div>;
interface CtaButtonProps {
  children: React.ReactNode;
  subtext?: string;
  onClick?: () => void;
  variant?: 'primary' | 'final';
  className?: string;
}
export const CtaButton = ({
  children,
  subtext,
  onClick,
  variant = 'primary',
  className = ''
}: CtaButtonProps) => {
  const isFinal = variant === 'final';
  const CHECKOUT_URL = 'https://tres33group.com//cart/43225681821757:1';
  const handleClick = () => {
    trackAddToCart();
    if (onClick) {
      onClick();
      return;
    }
    window.location.href = CHECKOUT_URL;
  };
  return <div className={`flex flex-col items-center w-full max-w-2xl mx-auto ${className}`} data-id="element-374">
      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={handleClick} className={`relative w-full group overflow-hidden rounded-lg font-bold text-center transition-all duration-300
          ${isFinal ? 'bg-gradient-to-r from-burgundy via-burgundy-dark to-burgundy text-white py-6 text-xl md:text-2xl border border-burgundy/50 shadow-[0_0_40px_rgba(123,30,58,0.4)]' : 'bg-gradient-to-r from-gold-dark via-gold to-gold-dark text-mystic-900 py-5 text-lg md:text-xl shadow-[0_0_30px_rgba(200,168,75,0.3)]'}`} data-id="element-375">
        <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-376"></div>
        <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-377">
          {children}
        </span>
      </motion.button>

      {subtext && <p className="mt-3 text-xs md:text-sm text-text-secondary flex items-center justify-center gap-4 flex-wrap" data-id="element-378">
          {subtext}
        </p>}
    </div>;
};